export const ERROR_MESSAGES = {
  INVALID_CODE: 'remotePickup.enterCode.invalidPickupCode',
  CODE_NOT_FOUND: 'ttw.codeNotFoundMsg',
  SEE_ASSOCIATE: 'ttw.seeAssociateMsg',
  SEE_ATTENDANT: 'common.seeAttendantMsg',
  PICKUP_UNAVAILABLE: 'ttw.pickUpUnavailableProcessMsg',
  INVALID_DISPENSE_STATE: 'remotePickup.enterCode.dispenseInvalidState',
  PICKUP_IN_ANOTHER_DEVICE: 'common.pickupInAnotherDeviceMsg',
  ORDER_ALREADY_RECLAIMED: 'ttw.orderAlreadyReclaimedMsg',
  ORDER_ALREADY_PICKED_UP: 'ttw.orderAlreadyPickedUpMsg',
  PICKUP_START_FAILED: 'Pickup start failed',
  PICKUP_STATE_UPDATE_FAILED: 'Pickup state update failed',
  ORDER_NOT_READY_FOR_PICKUP: 'common.orderNotReadyForPickup',
};
